import { Component } from '@angular/core';

@Component({
  selector: 'ngx-products-widget',
  templateUrl: './products-widget.component.html',
  styleUrls: ['./products-widget.component.scss']
})
export class ProductsWidgetComponent {
  constructor(){}
}
